import { createFileRoute } from '@tanstack/react-router';
import { VoterPageShell } from '../components/voting/VoterScreens';
import PublicHome from '../pages/public/Home';
import { getVotingPageData } from '../lib/server/voting';

export const Route = createFileRoute('/')({
  loader: () => getVotingPageData(),
  component: PublicPage,
});

function PublicPage() {
  return (
    <VoterPageShell>
      <PublicHome />
    </VoterPageShell>
  );
}
